module.exports = __webpack_public_path__ + "img/logo_roxo.afaaa527.svg";